import { VStack, HStack, View, Pressable } from "@gluestack-ui/themed";
import { ListTileProps } from "./types";
import { Icon } from "@repo/core/components/core/Icon";
import { TileLabel } from "./components/TileLabel";
import Spinner from "../../core/Spinner";

export const ListTile = ({
  id,
  isActive = false,
  isLoading,
  labels,
  leading,
  isSelectable,
  trailing,
  labelsGap = "$0",
  onPress
}: ListTileProps) => {
  const borderColor = isActive ? "$primary700" : "$borderLight100";
  const backgroundColor = isActive ? "$primary0" : "$backgroundLight50";
  return (
    // @ts-ignore
    <Pressable
      w="$full"
      alignSelf="stretch"
      $md-cursor={isSelectable ? "pointer" : "default"} // The glustack not provide "default" props for cursor
      variant={isSelectable ? "selectable" : "ghost"}
      onPress={() => onPress?.(id)}
    >
      <VStack
        p="$2"
        w="$full"
        alignSelf="stretch"
        borderWidth={1}
        borderRadius={"$lg"}
        bg={backgroundColor}
        borderColor={borderColor}
      >
        <HStack gap="$3">
          {leading && (
            <VStack alignItems="center" justifyContent="center">
              {leading}
            </VStack>
          )}
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          <VStack rowGap={labelsGap as any} justifyContent="center" flex={1}>
            {!!labels?.length &&
              labels.map(
                (label, index) =>
                  label.text && (
                    <TileLabel
                      key={label.key || index}
                      text={label.text}
                      fontColor={label.fontColor}
                      fontFamily={label.fontFamily}
                      fontWeight={label.fontWeight}
                      fontSize={label.fontSize}
                    />
                  )
              )}
          </VStack>
          {trailing && <VStack>{trailing}</VStack>}
          {isActive && !isLoading ? (
            <View position="absolute" top={0} right={0}>
              <Icon name="check-circle" size="20" color="$primary700" />
            </View>
          ) : isActive && isLoading ? (
            <View position="absolute" top={0} right={0}>
              <Spinner size={20} />
            </View>
          ) : null}
        </HStack>
      </VStack>
    </Pressable>
  );
};
